import React from 'react';
import HeroSection from './HeroSection';
import InvestmentSection from './InvestmentSection';
import HowWeHelpSection from './HowWeHelpSection';
import JoinTheClub from './JoinTheClub';
const ResearchPage: React.FC = () => {
  return (
    <>
      <HeroSection />
      <InvestmentSection />
      <HowWeHelpSection />
      <JoinTheClub />
    </>
  );
};

export default ResearchPage;
